// Key dates rail for funding pages (templates/_components/fund/timeline.twig). Advances every few
// seconds while on screen; hover or focus holds it, the arrows and axis dates stop it for good, and
// it never moves on its own for visitors who prefer reduced motion.
export default (count) => ({
    active: 0,
    offset: 0,
    held: false,
    stopped: false,
    visible: false,
    touchX: null,

    init() {
        this.measure();
        window.addEventListener('resize', () => this.measure(), { passive: true });

        new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting;
        }, { threshold: 0.3 }).observe(this.$el);

        if (count > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            setInterval(() => {
                if (this.visible && !this.held && !this.stopped) {
                    this.next();
                }
            }, 4500);
        }
    },

    hold(state) {
        this.held = state;
    },

    stop() {
        this.stopped = true;
    },

    // Swipe left or right on the cards to move one date (phones and tablets).
    touchStart(event) {
        this.touchX = event.touches[0].clientX;
    },

    touchEnd(event) {
        const dx = event.changedTouches[0].clientX - (this.touchX ?? event.changedTouches[0].clientX);
        if (Math.abs(dx) > 40) {
            dx < 0 ? this.next() : this.prev();
            this.stop();
        }
    },

    next() {
        this.go((this.active + 1) % count);
    },

    prev() {
        this.go((this.active - 1 + count) % count);
    },

    go(index) {
        this.active = index;
        this.measure();
    },

    // Slide so the active card sits at the left edge, without running past the last card.
    measure() {
        const { rail, viewport } = this.$refs;
        if (!rail || !viewport) {
            return;
        }
        const card = rail.children[this.active];
        const max = Math.max(0, rail.scrollWidth - viewport.clientWidth);
        this.offset = Math.min(card ? card.offsetLeft : 0, max);
    },
});
